import React from 'react';
import { createRoot } from 'react-dom/client'; // 변경된 임포트
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import {store2} from './store';
import { setAppVersion, setFcmToken, setVersion } from './reduxToolkit/redux';

import './scss/reset.scss';

// Android와 iOS WebView가 호출할 앱 버전 수신 함수를 등록한다.
const receiveAppVersion = function(version) {
    if (version) {
        localStorage.setItem('AppVersion', version);
        store2.dispatch(setAppVersion(version));
        store2.dispatch(setVersion(version));
    }
};
window.AppVersion = receiveAppVersion;
window.AppVersion_ios = receiveAppVersion;

// iOS WebView 브리지 호출 여부와 관계없이 URL로 전달된 버전도 즉시 반영한다.
const nativeVersionFromUrl = new URLSearchParams(window.location.search).get('nativeVersion');
if (nativeVersionFromUrl) {
    receiveAppVersion(nativeVersionFromUrl);
}

window.FcmToken = function(res) {
    if (res) {
        store2.dispatch(setFcmToken(res));
    }
};

const root = createRoot(document.getElementById('root')); // createRoot 사용
root.render(
  // <React.StrictMode>
     <Provider store={store2}>
    <Router>
      <App />
    </Router>
    </Provider>
  // </React.StrictMode>
);
